import React from 'react';

interface FinanceItemProps {
  label: string;
  value: string;
  sub?: string;
  icon?: React.ReactNode;
  highlight?: boolean;
  color?: string;
  isPrivate?: boolean;
  className?: string;
}

export const FinanceItem: React.FC<FinanceItemProps> = ({ label, value, sub, icon, highlight, color, isPrivate, className }) => {
  const styles: any = {

    success: 'bg-success/5 border-success/10 text-success',
    danger: 'bg-danger/5 border-danger/10 text-danger',
    blue: 'bg-blue-500/5 border-blue-500/10 text-blue-500',
    slate: 'bg-muted/30 border-border text-foreground'
  };

  if (highlight) {
    return (
      <div className={`p-2.5 md:p-4 bg-primary/5 flex flex-col gap-1 border-x first:border-l-0 last:border-r-0 border-border/50 ${className || ''}`}>
        <div className="flex items-center gap-1.5 opacity-60">
          {icon}
          <p className="text-[8px] md:text-[10px] font-bold uppercase tracking-tight">{label}</p>
        </div>
        <p className="text-sm md:text-xl font-black text-primary tabular-nums leading-tight">
          {isPrivate ? '****' : value}
        </p>
        {sub && <p className="text-[7px] md:text-[9px] font-medium text-muted-foreground uppercase opacity-60 truncate">{sub}</p>}
      </div>
    );
  }

  return (
    <div className={`p-2.5 md:p-4 flex flex-col gap-1 border-x first:border-l-0 last:border-r-0 border-border/50 ${className || ''}`}>
      <div className="flex items-center gap-1.5 opacity-60">
        {icon}
        <p className="text-[8px] md:text-[10px] font-bold uppercase tracking-tight">{label}</p>
      </div>
      <p className={`text-sm md:text-xl font-black tabular-nums leading-tight ${color || 'text-foreground'}`}>
        {isPrivate ? '****' : value}
      </p>
      {sub && <p className="text-[7px] md:text-[9px] font-medium text-muted-foreground uppercase opacity-60 truncate">{sub}</p>}
    </div>
  );
};

export const PriceBox = ({ label, value, color, isPrivate, sub }: { label: string; value: string; color: string; isPrivate?: boolean; sub?: string }) => {
  const styles: any = {

    success: 'bg-success/10 border-success/20 text-success',
    danger: 'bg-danger/10 border-danger/20 text-danger',
    blue: 'bg-blue-500/10 border-blue-500/20 text-blue-500',
    slate: 'bg-muted/30 border-border text-muted-foreground'
  };

  return (
    <div className={`p-2 md:p-3 rounded-2xl border ${styles[color] || styles.slate}`}>
      <p className="text-[8px] md:text-[9px] font-bold uppercase opacity-60 mb-0.5">{label}</p>
      <div className="flex flex-col gap-0.5">
        <p className="text-xs md:text-sm font-black tabular-nums leading-none">
          {isPrivate ? '****' : value}
        </p>
        {sub && <p className="text-[8px] md:text-[10px] font-bold opacity-80 mt-1">{sub}</p>}
      </div>
    </div>
  );
};
